import md5 from 'js-md5'
const setLoginPassMd5 = (pass) => {
  const str = 'UyG$sABTnToAV9AF'
  return md5(pass + str)
}
const setTransactionPassMd5 = (pass) => {
  const str = 'z*ZoBOft3wt#K85l'
  return md5(pass + str)
}
export {
  setLoginPassMd5,
  setTransactionPassMd5
}
